// Turner & Walker live‑chat controller  (v5 – sticky close state)
// • Adds a CSS class with !important so vendor re‑styles can’t reopen the button.
// • Rebuilds the banner if it disappeared after soft‑navigation.
// • Adds/Removes class on *every* tick (5 s) so button never revives.

function setChatVisibilityFinal() {
  /* ====================================================
     0.  Inject hard‑close CSS class                     
  ====================================================*/
  const style=document.createElement('style');
  style.textContent='.tw-chat--closed{pointer-events:none !important;opacity:0.5 !important;cursor:not-allowed !important;}';
  document.head.appendChild(style);

  /* ====================================================
     1.  Bank‑holiday table (England & Wales)            
  ====================================================*/
  function easterDate(y){const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),M=Math.floor((h+l-7*m+114)/31),D=((h+l-7*m+114)%31)+1;return new Date(Date.UTC(y,M-1,D));}
  function holidays(y){const H=[],add=(n,m,d)=>{let dt=new Date(Date.UTC(y,m,d));const w=dt.getUTCDay();if(w===6)dt.setUTCDate(d+2);else if(w===0)dt.setUTCDate(d+1);H.push([n,dt]);};add('New Year’s Day',0,1);const e=easterDate(y);H.push(['Good Friday',new Date(e-1728e5)],['Easter Monday',new Date(+e+864e5)]);const firstMon=m=>{let d=new Date(Date.UTC(y,m,1));while(d.getUTCDay()!=1)d.setUTCDate(d.getUTCDate()+1);return d},lastMon=m=>{let d=new Date(Date.UTC(y,m,31));while(d.getUTCDay()!=1)d.setUTCDate(d.getUTCDate()-1);return d};H.push(['Early May Bank Holiday',firstMon(4)],['Spring Bank Holiday',lastMon(4)],['Summer Bank Holiday',lastMon(7)]);add('Christmas Day',11,25);add('Boxing Day',11,26);return H;}
  const yr=new Date().getFullYear();
  const HOL=Object.fromEntries([...holidays(yr),...holidays(yr+1)].map(([n,d])=>[d.toISOString().slice(0,10),n]));
  const WD=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  /* ====================================================
     2.  Helper banner                                   
  ====================================================*/
  let box=null, nextTxt=null;
  function ensureBanner(btn){
    if(box && document.contains(box)) return;  // already in DOM
    box=document.createElement('div');Object.assign(box.style,{fontSize:'12px',color:'#888',marginTop:'5px',textAlign:'center'});
    box.innerHTML='<div>🕒 Live chat available from 9am–4:30pm Mon–Fri</div><div style="height:10px"></div><div id="tw-next" style="font-size:11px;color:#aaa"></div><div style="height:15px"></div>';
    nextTxt=box.querySelector('#tw-next');
    btn.parentElement.insertBefore(box,btn.nextSibling);
  }

  /* ====================================================
     3.  Core ticker (5 s)                               
  ====================================================*/
  function tick(){
    const btn=document.querySelector('.custom-get-started__chat-btn');
    if(!btn){setTimeout(tick,1000);return;}
    ensureBanner(btn);

    const now=new Date(), day=now.getDay(), mins=now.getHours()*60+now.getMinutes(),
          weekday=day>0&&day<6, key=now.toISOString().slice(0,10), hol=HOL[key],
          open=weekday&&!hol&&mins>=540&&mins<=990; // 09:00–16:30

    if(open){btn.classList.remove('tw-chat--closed'); nextTxt.textContent=''; box.style.display='none'; return;}

    // closed state
    btn.classList.add('tw-chat--closed');
    box.style.display='block';

    // next opening
    const next=new Date(now); next.setHours(9,0,0,0);
    do{next.setDate(next.getDate()+1);}while([0,6].includes(next.getDay())||HOL[next.toISOString().slice(0,10)]);
    const diffMs=next-now, diffHrs=Math.ceil(diffMs/36e5), dayName=WD[next.getDay()];

    if(hol){nextTxt.textContent=diffHrs<24?`Live chat is unavailable today for the ${hol}. We’ll be back tomorrow at 9am.`:`Live chat is unavailable for the ${hol}. We’ll be back on ${dayName} at 9am.`;}
    else if(!weekday||mins>990){nextTxt.textContent=diffHrs>=24?`We will be back on ${dayName} at 9am.`:`We will be back in approx ${diffHrs} hour${diffHrs!==1?'s':''}.`;}
    else {const h=Math.ceil((540-mins)/60);nextTxt.textContent=`We will be back in approx ${h} hour${h!==1?'s':''}.`;}
  }

  tick();
  setInterval(tick,5000);
}

document.addEventListener('DOMContentLoaded',setChatVisibilityFinal);
